import React, { Component } from "react";
import "./ObTile.scss";
import className from "../../../shared/className";
import ObWaveform from "./ObWaveform";
import ObVitals from "./ObVitals";
import CervicalExams from "./CervicalExams";
import Annotations from "./Annotations";
import Pitocin from "./Pitocin";
import ObOther from "./ObOther";
import ObVitalsExpanded from "../../ObVitalsExpanded";
import Loader from "../../../shared/Loader";
import Icon from "../../../shared/Icon";
import { observer } from "mobx-react";

class Tile extends Component {
  render() {
    const specifics = this.props?.patient?.moduleSpecificData?.[0];

    let membraneStatus, epiduralStatus, ega;

    if (specifics) {
      if ("membraneStatus" in specifics && specifics?.membraneStatus !== "--") {
        membraneStatus = specifics?.membraneStatus;
      }
      if ("epiduralStatus" in specifics && specifics?.epiduralStatus !== "--") {
        epiduralStatus = specifics?.epiduralStatus;
      }
      if ("ega" in specifics && specifics?.ega !== "--") {
        ega = specifics?.ega;
      }
    }

    return (
      <div
        {...className({
          tile: true,
          "ob-tile": true,
          [`${this.props.tileType}-ob-tile`]: 1,
          expanded: this.props.expanded,
        })}
        onClick={this.props.expanded ? null : this.props.onClick}
      >
        {this.props.loading ? (
          <Loader />
        ) : (
          <React.Fragment>
            {this.props.tileType === "waveform" ? (
              <header>
                <span>
                  {membraneStatus && (
                    <span>
                      <b>Membrane:</b> {membraneStatus}
                    </span>
                  )}
                  {membraneStatus && epiduralStatus && <span> • </span>}
                  {epiduralStatus && (
                    <span>
                      <b>Epidural:</b> {epiduralStatus}
                    </span>
                  )}
                </span>
                <span>
                  {ega ? (
                    <span>
                      <b>EGA:</b> {ega}{" "}
                    </span>
                  ) : null}
                  {this.props.toggleLiveMode ? (
                    <span
                      {...className({
                        live: true,
                        active:
                          this.props.liveMode ||
                          this.props.parent.store.liveModeLoading,
                      })}
                      onClick={this.props.toggleLiveMode}
                    >
                      Live
                    </span>
                  ) : null}
                </span>
              </header>
            ) : (
              <header>
                {String(
                  this.props?.model?.title ||
                    this.props?.title ||
                    this.props?.tileType,
                )}
                {
                  // If the model has count, display it.
                  typeof this.props?.model?.count !== "undefined" &&
                  !this.props.expanded ? (
                    <span className="count">{this.props?.model?.count}</span>
                  ) : null
                }
                {this.props.expanded ? (
                  <Icon symbol="x" onClick={this.props.onClick} />
                ) : (
                  <div className={"header-icon"}></div>
                )}
              </header>
            )}
            <div className="content">{this.tileContents}</div>
          </React.Fragment>
        )}
      </div>
    );
  }

  get tileContents() {
    const Tile = {
      annotations: Annotations,
      cervicalexams: CervicalExams,
      obvitals: this.props.expanded ? ObVitalsExpanded : ObVitals,
      other: ObOther,
      pitocin: Pitocin,
      waveform: ObWaveform,
    }[this.props.tileType];

    return <Tile {...this.props} />;
  }
}

export default observer(Tile);
